import React from "react";
import ColorSwitcher from "./ColorSwitcher";
import LanguageSwitcher from "./LanguageSwitcher";
import NavbarOpen from "./NavbarOpen";
import { NavLink } from "react-router-dom";
  
function Nav() {

  let activeStyle = {
    textDecoration: "underline",
  };

  return (
      <nav className="w-full flex-row flex-wrap items-center px-2 py-3">
        <div className="flex md:flex-row container justify-between px-2 mx-auto flex-wrap items-center content-around">
          
          
        <div className="order-3 my-1 lg:mx-[5vw] items-center">
            
            <LanguageSwitcher />

          </div>
          
          
          <div className="order-1 my-1 lg:mx-[5vw] items-center">
            
            <ColorSwitcher />

          </div>
          <div className="order-4 lg:order-2 w-full lg:mx-[5vw] lg:mr-12 relative flex lg:w-auto lg:static lg:block lg:justify-end justify-center">

            <NavbarOpen />

          </div>

          

          

          <div className="order-2 lg:order-5	lg:mx-[5vw] lg:ml-12 relative flex lg:w-auto lg:static lg:block lg:justify-start justify-center">
            <h1> 
            <NavLink 
              className="hover:font-black text-xxl font-bold leading-relaxed inline-block py-2 whitespace-nowrap"
              to="/"
              style={({ isActive }) =>
              isActive ? activeStyle : undefined
              }
            end>
            vincent charlebois</NavLink>
            </h1>
          </div>

        </div>
      </nav>
  );
}

export default Nav;